import { colors, typography } from "../../../design/tokens";
import { StoreType } from "../../../model/rankings";

interface AppStoreRankingsStoreToggleProps {
  selected: StoreType;
  onChange: (store: StoreType) => void;
}

export function AppStoreRankingsStoreToggle({
  selected,
  onChange,
}: AppStoreRankingsStoreToggleProps) {
  return (
    <div className={`flex items-center ${colors.surface.secondary} rounded-full p-1`}>
      <button
        onClick={() => onChange("android")}
        className={`px-6 py-2 rounded-full ${typography.size.sm} ${typography.weight.medium} transition-all duration-200 ${
          selected === "android"
            ? "bg-primary-blue text-white"
            : `${colors.text.secondary} hover:text-white`
        }`}
      >
        Android
      </button>
      <button
        onClick={() => onChange("ios")}
        className={`px-6 py-2 rounded-full ${typography.size.sm} ${typography.weight.medium} transition-all duration-200 ${
          selected === "ios"
            ? "bg-primary-blue text-white"
            : `${colors.text.secondary} hover:text-white`
        }`}
      >
        iOS
      </button>
    </div>
  );
}
